// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#onboarding-container {
    width: 100vw;
    max-width: 450px;
    min-height: 100vh;
    background-color: #000000;
    position: relative;
    display: flex;
    flex-direction: column;
    padding-left: 24px;
    padding-right: 24px;
}

#screen-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
}

.back-button {
    position: absolute;
    top: 10px;
    left: 0px;
    background: none;
    border: none;
    color: #ffffff;
    font-size: 30px;
    cursor: pointer;
    z-index: 10;
    margin-left: 20px;
}

.back-button:hover {
    opacity: 0.7;
}

.progress-wrapper {
    position: relative;
    width: 100%;
}

.progress-container {
    position: relative;
    width: 100%;
    height: 4px;
    background-color: #333;
    border-radius: 2px;
    overflow: hidden;
    margin: 2px auto;
}

.progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #A145B0, #A145B0);
    border-radius: 2px;
    transition: width 0.3s ease;
}

.progress-dots {
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.progress-dot {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #333;
    border: 2px solid #333;
    position: relative;
    z-index: 2;
}

.progress-dot.completed {
    background-color: #A145B0;
    border-color: #A145B0;
}

.progress-dot.completed::after {
    font-family: Montserrat, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
    content: "✓";
    color: #fff;
    font-size: 10px;
    top: -5px;
    left: 2px;
    position: relative;
}

.progress-dot.current {
    background-color: #A145B0;
    border-color: #A145B0;
}

.header-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    z-index: 5;
    padding-bottom: 24px;
}

.header-container .element-image {
    width: auto;
    height: auto;
    object-fit: contain;
    margin: 0;
}

.header-container .progress-wrapper {
    width: 100%;
}

.content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    transition: opacity 0.3s ease;
    padding-bottom: 100px;
}

.content-area {
    margin-top: 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.bottom-section {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
    z-index: 15;
}

@media (max-width: 480px) {
    #screen-content {
        padding: 0px;
    }

    .element-h1 {
        font-size: 24px;
    }

    .bottom-section {
        padding: 16px;
        padding-bottom: calc(16px + env(safe-area-inset-bottom));
    }

    .content-container {
        padding-bottom: 90px;
    }

    .element-floating-timer.sticky {
        width: calc(100% - 32px);
    }

    .floating-timer-text {
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gHAAgH;IAChH,YAAY;IACZ,WAAW;IACX,eAAe;IACf,SAAS;IACT,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,wDAAwD;IACxD,WAAW;AACf;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,wDAAwD;IAC5D;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["#onboarding-container {\n    width: 100vw;\n    max-width: 450px;\n    min-height: 100vh;\n    background-color: #000000;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    padding-left: 24px;\n    padding-right: 24px;\n}\n\n#screen-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-height: 100vh;\n}\n\n.back-button {\n    position: absolute;\n    top: 10px;\n    left: 0px;\n    background: none;\n    border: none;\n    color: #ffffff;\n    font-size: 30px;\n    cursor: pointer;\n    z-index: 10;\n    margin-left: 20px;\n}\n\n.back-button:hover {\n    opacity: 0.7;\n}\n\n.progress-wrapper {\n    position: relative;\n    width: 100%;\n}\n\n.progress-container {\n    position: relative;\n    width: 100%;\n    height: 4px;\n    background-color: #333;\n    border-radius: 2px;\n    overflow: hidden;\n    margin: 2px auto;\n}\n\n.progress-bar {\n    height: 100%;\n    background: linear-gradient(90deg, #A145B0, #A145B0);\n    border-radius: 2px;\n    transition: width 0.3s ease;\n}\n\n.progress-dots {\n    position: absolute;\n    top: -5px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.progress-dot {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background-color: #333;\n    border: 2px solid #333;\n    position: relative;\n    z-index: 2;\n}\n\n.progress-dot.completed {\n    background-color: #A145B0;\n    border-color: #A145B0;\n}\n\n.progress-dot.completed::after {\n    font-family: Montserrat, system-ui, -apple-system, \"system-ui\", \"Segoe UI\", Roboto, \"Helvetica Neue\", sans-serif;\n    content: \"✓\";\n    color: #fff;\n    font-size: 10px;\n    top: -5px;\n    left: 2px;\n    position: relative;\n}\n\n.progress-dot.current {\n    background-color: #A145B0;\n    border-color: #A145B0;\n}\n\n.header-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    z-index: 5;\n    padding-bottom: 24px;\n}\n\n.header-container .element-image {\n    width: auto;\n    height: auto;\n    object-fit: contain;\n    margin: 0;\n}\n\n.header-container .progress-wrapper {\n    width: 100%;\n}\n\n.content-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    transition: opacity 0.3s ease;\n    padding-bottom: 100px;\n}\n\n.content-area {\n    margin-top: 10px;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.bottom-section {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    max-width: 400px;\n    margin: 0 auto;\n    padding: 20px;\n    padding-bottom: calc(20px + env(safe-area-inset-bottom));\n    z-index: 15;\n}\n\n@media (max-width: 480px) {\n    #screen-content {\n        padding: 0px;\n    }\n\n    .element-h1 {\n        font-size: 24px;\n    }\n\n    .bottom-section {\n        padding: 16px;\n        padding-bottom: calc(16px + env(safe-area-inset-bottom));\n    }\n\n    .content-container {\n        padding-bottom: 90px;\n    }\n\n    .element-floating-timer.sticky {\n        width: calc(100% - 32px);\n    }\n\n    .floating-timer-text {\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
